import { browserTracingIntegration, init } from "@sentry/react";

const defaultTracesSampleRate = 1.0;
const parseBoolean = (value: string): boolean => value === "true";
const parseNumber = (
  value: string | undefined,
  defaultValue: number
): number => {
  const parsed = Number(value);
  return Number.isNaN(parsed) ? defaultValue : parsed;
};

init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  beforeSend(event) {
    const values = event.exception?.values ?? [];
    if (values.some((v) => v.value === "Network Error")) {
      return null;
    }
    return event;
  },
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: parseBoolean(
    import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII ?? "true"
  ),
  integrations: [browserTracingIntegration()],
  enableLogs: parseBoolean(import.meta.env.VITE_SENTRY_ENABLE_LOGS ?? "false"),
  tracesSampleRate: parseNumber(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    defaultTracesSampleRate
  ),
  tracePropagationTargets: [/^\//, /^https:\/\/app\.nilahealth\.ai/],
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
});
